module.exports = __webpack_public_path__ + "img/id.23848526.png";